import { css } from 'styled-components';
import { colors } from '../../atoms/colors/colors';
import { spacing } from '../../atoms/spacing/spacing';
import { complementaryColors } from '../../atoms/colors/complementary-colors';
import { DropdownTags } from './class-name-tags';
export const dropdownCommonTheme = {
    trigger: css `
    --error-color: ${colors.red600};
    --border-color: ${colors.coolgrey300};
    --background-color: ${colors.white};
    --color: ${colors.ultramarine900};
    --disabled-color: ${complementaryColors.coolgrey450};
    --placeholder-color: ${colors.coolgrey600};

    background-color: var(--background-color);
    padding: ${spacing.spacing4} ${spacing.spacing8};
    border-radius: 4px;
    border: 1px solid var(--border-color);
    height: 36px;
    box-sizing: border-box;

    &.compact {
      height: 24px;
    }

    &.error {
      border-bottom-left-radius: 0;
      border-bottom-right-radius: 0;
      border-bottom-width: 2px;
      outline-color: var(--error-color);
      border-bottom-color: var(--error-color);
    }

    & .${DropdownTags.itemText} {
      color: var(--color);
    }

    &[data-disabled]
      .${DropdownTags.triggerText},
      &[data-disabled]
      .${DropdownTags.itemText} {
      color: var(--disabled-color);
    }

    &[data-placeholder]:not([data-disabled]) .${DropdownTags.triggerText} {
      color: var(--placeholder-color);
    }
  `,
    triggerIcon: css `
    --color: ${complementaryColors.coolgrey450};
    color: var(--color);
  `,
    item: css `
    --color: ${colors.ultramarine900};
    --focus-background-color: ${colors.coolgrey200};
    --active-background-color: ${colors.coolgrey100};
    --active-color: ${colors.ultramarine900};
    --disabled-text-color: ${colors.coolgrey400};
    --negative-color: ${colors.red600};
    padding: ${spacing.spacing4} ${spacing.spacing8};
    border-radius: 4px;

    &:focus {
      background-color: var(--focus-background-color);
    }

    .${DropdownTags.itemText} {
      color: var(--color);
    }

    & .negative.${DropdownTags.itemText} {
      color: var(--negative-color);
    }

    & .disabled.${DropdownTags.itemText} {
      color: var(--disabled-text-color);
    }

    &[data-state='checked'] {
      background-color: var(--active-background-color);

      .${DropdownTags.itemText} {
        color: var(--active-color);
        font-weight: bold;
      }
    }
  `,
    content: css `
    --background-color: ${colors.white};
    --scroll-icon-color: ${colors.ultramarine900};
    --separator-color: ${colors.coolgrey300};
    --section-label-color: ${colors.ultramarine900};
    background-color: var(--background-color);
    border-radius: 4px;
    border-color: var(--background-color);
    padding: ${spacing.spacing4};
    box-shadow: 0px 10px 38px -10px rgba(22, 23, 24, 0.35),
      0px 10px 20px -15px rgba(22, 23, 24, 0.2);

    & .${DropdownTags.sectionLabel} {
      color: var(--section-label-color);
      margin: ${spacing.spacing8};
    }

    & .${DropdownTags.scrollDownButton}, & .${DropdownTags.scrollUpButton} {
      color: var(--scroll-icon-color);
    }

    & .${DropdownTags.separator} {
      height: 1px;
      margin: ${spacing.spacing8};
      background-color: var(--separator-color);
    }
  `,
};
//# sourceMappingURL=common-theme.js.map